<template>
  <card>
    <list
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="true"
      :isAdd="true"
      :isPush="true"
      @push="isPush = true"
      :itemLink="itemLink"
      :setLink="setLink"
      :openItem="true"
      :fields="fields"
      :searchDisable="false"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
      :filters="filters"
      :setImport="true"
      :exportFields="exportFields"
    />
    <!-- <import-client></import-client> -->

    <push-client v-if="isPush" @close="isPush = false"></push-client>
  </card>
</template>
<script>
import ImportClient from "@/components/ImportClient";
import PushClient from "@/components/PushClient";
export default {
  name: "products",
  components: {
    ImportClient,
    PushClient,
  },
  methods: {
    changeFunction(val) {},
    change(val) {},
    importItem() {},
  },
  data() {
    return {
      exportFields: {
        "Номер ученика": "id",
        "Полное имя": "full_name",
        Класс: {
          field: "group.title",
          callback: (value) => {
            return value && value !== " " ? value + " класс" : "Нет";
          },
        },
        "Номер телефона": {
          field: "phone",
          callback: (value) => {
            return "UZ " + value;
          },
        },
      },
      isPush: false,
      val: [],
      filters: [
        {
          key: "group",
          title: "Группа (только в актуальных классах)",
        },
        {
          title: "Сезон",
          pushLink: `${process.env.HOST_URL}/api/v3/schools/${this.$store.state.business.id}/school_seasons`,
          single: false,
          key: "seasons",
          queryKey: "season",
        },
      ],
      modalCreate: "client",
      fields: [
        {
          col: "col-12 col-md-6",
          key: "phone",
          label: "Номер телефона",
          type: "mask",
          mask: "+998#########",
          placeholder: "+998",
        },
        {
          col: "col-12 col-md-6",
          key: "last_name",
          label: "Фамилия",
          type: "field",
          textType: "text",
        },
        {
          col: "col-12 col-md-6",
          key: "first_name",
          label: "Имя",
          type: "field",
          textType: "text",
          readonly: false,
        },
        {
          col: "col-12 col-md-6",
          key: "father_name",
          label: "Отчество",
          type: "field",
          textType: "text",
          readonly: false,
        },
        {
          col: "col-12 col-md-6",
          key: "password",
          label: "Пароль",
          textType: "field",
          type: "field",
        },
        {
          col: "col-12 col-md-6",
          key: "birthday",
          label: "Дата рождения",
          textType: "date",
          type: "field",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_client",
      itemLink: "business/clients",
      setLink: "business/clients",
      columns: [
        {
          key: "id",
          title: "Login",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "full_name",
          title: "Ученик",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "phone",
          title: "Номер телефона",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "group",
          title: "Класс",
          object: "title",
          disableLink: true,
        },
        {
          key: "business",
          title: "Школа",
          object: "title",
          disableLink: true,
        },
        {
          key: "created_at",
          title: "Создан",
          dateTimeFormat: true,
        },

        {
          detail: true,
          remove: false,
        },
      ],
    };
  },
};
</script>
<style>
</style>
